import { render, staticRenderFns } from "./RequestForm.vue?vue&type=template&id=2aa372a3&"
import script from "./RequestForm.vue?vue&type=script&lang=ts&"
export * from "./RequestForm.vue?vue&type=script&lang=ts&"
import style0 from "./RequestForm.vue?vue&type=style&index=0&id=2aa372a3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports